export const SPRII_ORDER_NO_COOKIE_EXPIRATION_DAYS = 2;
